import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 2rem 2rem;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  // for fitting container btw header for footer
  top: 7.2rem;
  height: calc(
    100vh - 7.2rem - ${({ noFooter }) => (noFooter ? '0rem' : '7.2rem')}
  );

  // aligning content
  position: relative;
`;
// add content
Container.Content = styled.div`
  width: 100%;
  max-width: 110rem;
  margin: auto;
`;

export const CardsContainer = styled.div`
  max-height: 50rem;
  overflow-x: hidden;
  overflow-y: scroll;
  text-align: center;

  ::-webkit-scrollbar {
    display: none;
  }
`;
